import styled from "styled-components";

export const Wrapper = styled.div`
    padding: ${({ theme }) => `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.large}`};
`;
